module.exports = __webpack_public_path__ + "img/Summary-50.ab25b182.jpg";